import type { Cell } from "../../lib/comparisons";

export const yes = (text: string): Cell => ({ verdict: "yes", text });
export const no = (text: string): Cell => ({ verdict: "no", text });
export const partial = (text: string): Cell => ({ verdict: "partial", text });
export const unstated = (text: string): Cell => ({ verdict: "unstated", text });
